/*
 * File: cell-promo-code-status.ts
 * Created: 2026-01-19 20:10:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellPromoCodeStatus extends BaseTableBodyCell {
    get beginAt() {
        return this.row?.beginAt ?? null;
    }

    get endAt() {
        return this.row?.endAt ?? null;
    }

    get inTimeRange() {
        const now = Date.now();
        const begin = this.parseDate(this.beginAt);
        const end = this.parseDate(this.endAt);
        if (begin != null && now < begin.getTime()) return false;
        if (end != null && now > end.getTime()) return false;
        return true;
    }

    get isOutOfRange() {
        return !this.inTimeRange;
    }

    get isActive() {
        return Boolean(this.row?.enable) && !this.isExhausted && this.inTimeRange;
    }

    get isExhausted() {
        const maxUses = this.row?.maxUses ?? null;
        if (maxUses == null) return false;
        const max = Number(maxUses) || 0;
        const used = Number(this.row?.usedCount ?? 0) || 0;
        if (max <= 0) return false;
        return used >= max;
    }

    get isInactive() {
        return !this.row?.enable && this.inTimeRange && !this.isExhausted;
    }

    get badgeClass() {
        if (this.isExhausted) return "badge-exhausted";
        if (this.isOutOfRange) return "badge-disabled";
        if (this.isActive) return "badge-active";
        return "badge-inactive";
    }

    get iconClass() {
        if (this.isExhausted) return "fa-ban";
        if (this.isOutOfRange) return "fa-ban";
        if (this.isActive) return "fa-check";
        return "fa-pause";
    }

    get statusLabel() {
        if (this.isExhausted) return this.$_("w_StatusExhausted");
        if (this.isOutOfRange) return this.$_("w_StatusDisabled");
        if (this.isActive) return this.$_("w_StatusActive");
        return this.$_("w_StatusInactive");
    }

    parseDate(value?: string | Date | null) {
        if (!value) return null;
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return null;
        return date;
    }
}
